<template>
  <v-toolbar app>
    <v-toolbar-side-icon @click="$emit('toggleNav')" />
    <v-toolbar-title>
      <v-layout
        class="go-home"
        row
        wrap
        @click="goHome()"
      >
        <!-- src="https://catalog.pinkfong.com/api/images/catalogLogo/" -->
        <v-img
          :src="require('../assets/pinkfong-symbol-ctlg.png')"
          width="30px"
          height="30px"
          style="margin-right: 10px;"
        />
        <span
          class="hidden-xs-only"
        >
          Pinkfong&nbsp;
        </span> Catalog
      </v-layout>
    </v-toolbar-title>
    <v-spacer />
    <v-toolbar-items>
      <v-menu
        fixed
        fixed-tabs
        left
        offset-y
        v-if="!!user"
      >
        <v-btn
          slot="activator"
          flat
          style="min-width: 48px; padding-right: 0px;"
        >
          <v-list-tile-title
            style="text-transform: none; !important;"
            class="hidden-xs-only"
          >
            {{ user.firstName || user.username }}
          </v-list-tile-title>
          <v-icon
            right
            dark
            class="hidden-xs-only"
          >
            arrow_drop_down
          </v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile
            @click="logout()"
          >
            <v-list-tile-title>
              로그아웃
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-menu
        fixed
        fixed-tabs
        left
        offset-y
      >
        <v-btn
          slot="activator"
          flat
          style="min-width: 48px; padding-right: 0px;"
        >
          <v-list-tile-title
            style="text-transform: none; !important;"
            class="hidden-xs-only"
          >
            {{ defaultLanguage.name }}
          </v-list-tile-title>
          <v-icon
            right
            dark
            class="hidden-xs-only"
          >
            arrow_drop_down
          </v-icon>
        </v-btn>
        <v-list dense>
          <v-list-tile
            v-for="lan in languageData"
            :key="lan.code"
            @click="changeLocalLanguage(lan)"
          >
            <v-list-tile-title>
              {{ lan.name }}
            </v-list-tile-title>
          </v-list-tile>
        </v-list>
      </v-menu>
      <v-btn
        slot="activator"
        icon
        large
        color="grey darken-1"
        style="margin-right: 14px;"
        @click="$router.push({ path: '/' + defaultLanguage.code + '/selected' })"
      >
        <v-badge
          bottom
          color="rgb(255 103 175)"
          :value="countSelectedItems !== 0"
        >
          <v-icon color="grey lighten-4">
            assignment_turned_in
          </v-icon>
          <span slot="badge">
            {{ countSelectedItems }}
          </span>
        </v-badge>
      </v-btn>
    </v-toolbar-items>
    <v-dialog
      v-model="dialog"
      hide-overlay
      persistent
      width="300"
    >
      <v-card
        color="grey"
        dark
      >
        <v-card-text>
          {{ $t("message.downloading") }}
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          />
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-toolbar>
</template>

<script>
import { mapMutations } from 'vuex'
import { saveAs } from 'file-saver'

export default {
  data () {
    return {
      URL: '/api/products/pdf/',
      defaultLanguage: null,
      languageData: [
        {
          name: '한국어',
          code: 'ko'
        },
        {
          name: 'English',
          code: 'en'
        }
      ],
      dialog: false,
      user: null
    }
  },
  computed: {
    countSelectedItems () {
      return this.$store.getters.countSelected
    }
  },
  beforeMount () {
    this.setDefaultLanguage()
    this.fetchUser()
  },
  created () {
    this.$eventBus.$on('hideNav', this.hideNav)
  },
  destroyed () {
    this.$eventBus.$off('hideNav')
  },
  methods: {
    ...mapMutations({
      flush: 'flush'
    }),
    hideNav () {
      this.$emit('toggleNav')
    },
    getSelectedPdf () {
      const selectedItems = this.$store.getters.getSelectedData
      this.dialog = true
      this.$http({
        url: this.URL,
        method: 'post',
        data: {
          selectedUids: selectedItems,
          lang: this.$language.locale
        },
        responseType: 'blob'
      }).then(response => {
        saveAs(new Blob([response.data], { type: 'application/pdf' }), 'pinkfong.pdf')
        this.dialog = false
      }).catch(error => {
        this.dialog = false
        alert('시스템 에러', error)
      })
    },
    setDefaultLanguage: function () {
      const languageCode = this.$route.params.lang
      this.$language.locale = this.$route.params.lang
      const defaultLanguage = this.languageData.filter((ld) => {
        return ld.code === languageCode
      })
      this.defaultLanguage = defaultLanguage[0]
    },
    changeLocalLanguage: function (value) {
      this.$language.locale = value.code
      this.defaultLanguage = value
      this.$route.params.lang = value.code
      this.$router.push({ path: '/', params: { lang: value.code } })
      this.$eventBus.$emit('changeLocale')
      this.flush()
    },
    goHome: function () {
      this.$router.push({ path: '/home' })
    },
    fetchUser: async function () {
      try {
        await this.$store.dispatch('fetchUser')
        this.user = this.$store.getters.getUser
      } catch (err) {
        console.warn('유저 인증 실패!')
        console.log(err)
      }
    },
    logout: async function () {
      try {
        await this.$store.dispatch('logout')
        this.user = this.$store.getters.getUser
      } catch (err) {
        console.warn('유저 로그아웃 실패!')
        console.log(err)
      }
    }
  }
}
</script>
<style>
  .v-toolbar__title:not(:first-child) {
    margin-left: 0px;
  }
  div.v-toolbar__content {
    padding-right: 0px;
  }
  #checkstore {
    margin-right: 10px;
  }
  .go-home:hover{
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/app/Toolbar.vue